import utility from './utility'

const support = {
    init: function() {
        const contactForm = document.querySelector("#contact-support--form");
        if (contactForm) {
            contactForm.onsubmit = () => {
                grecaptcha.ready(function () {
                    grecaptcha.execute('6LfLgkkeAAAAAJjWeGBuwbL9vpDkOpKLfmiev0Rh', { action: 'support' }).then(function (token) {
                        document.getElementById('g-recaptcha-response').value = token;
                        support.submitContactForm();
                    });
                });
                return false;
            };


            const country = document.querySelector("#contact-support--form select[name='CountryCode']");
            if (country) {
                country.onchange = () => support.setStateInput();
            }
            support.setStateInput();


            //show hide request call back fields
            [...contactForm.querySelectorAll("input[name='RequestTypeId']")].map(item => {
                item.addEventListener('input', function (e) {
                    if (e.target.value === 'E') {
                        document.getElementById("callback-inputs").style.display = "none";
                    }
                    else {
                        document.getElementById("callback-inputs").style.display = "";
                    }
                })
            });
 

            //restrict to numeric
            [...contactForm.querySelectorAll("input[name='Phone']")].map(item => {
                item.onkeypress = (e) => {
                    if ((e.charCode < 48 || e.charCode > 57) && e.charCode != 43) {
                        e.preventDefault();
                    }
                };
            });
        }
    },

    submitContactForm: function() {
        const ajaxOptions = {
            url: "/api/web/support/contact-request",
            method: "POST",
            data: utility.getFormData(document.querySelector("#contact-support--form")),
            success: function(e) {
                const result = JSON.parse(e.target.responseText);
                const form = document.querySelector("#contact-support--form");
                utility.removeFormInputErrors(form);
                if (result.success) {
                    utility.showNotificationPopup({
                        title: "Success",
                        content: result.message
                    });
                     form.querySelector('[data-name="State"]').innerText = 'State';
                    form.querySelector('[data-name="CallbackTime"]').innerText = 'Select Time';
                    form.querySelector('[data-name="CallbackDay"]').innerText = 'Preferred Call Day';
                    form.querySelector('[data-name="CallbackTypeId"]').innerText = 'Select Callback Reason';
                    [...form.querySelectorAll("input[type=text]")].map(input => { input.value = ""; });
                    form.querySelector("textarea").value = "";
                    form.reset();
                    document.getElementById("callback-inputs").style.display = "block";

                }
                else if (result.fieldErrors) {
                    result.fieldErrors.map(error => {
                        utility.addFormInputError(form, error.Name, error.Error);
                    });
                }
            },
            always: function() {
                utility.enableButton(document.querySelector("#contact-support--form button[type=submit]"));
            }
        };
        utility.disableButton(document.querySelector("#contact-support--form button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    setStateInput: function () {
        const countrySelector = document.querySelector("#contact-support--form select[name='CountryCode']");
        if (countrySelector && (countrySelector.value === "" || countrySelector.value === "AU")) {
            document.getElementById("support-callback-state").style.display = "";
        }
        else {
            if (document.getElementById("support-callback-state")) {
            document.getElementById("support-callback-state").style.display = "none";
            }
        }
    },
};


export default support


// WEBPACK FOOTER //
// ./assets/src/js/classes/support.js